import * as React from "react";
const SvgLocation = () => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.574 2.21c-2.6 0-5.24 1.828-5.24 4.964 0 .706.31 1.59.838 2.562.521.959 1.223 1.944 1.935 2.839.71.893 1.423 1.683 1.958 2.251a.7.7 0 0 0 1.018 0 37 37 0 0 0 1.958-2.251c.712-.895 1.414-1.88 1.935-2.84.528-.97.838-1.855.838-2.561 0-3.136-2.64-4.965-5.24-4.965m0 13.912-.376.39-.002-.001-.003-.004-.014-.013-.05-.049-.188-.187A37.655 37.655 0 0 1 5.26 13.25c-.733-.92-1.477-1.961-2.04-2.996-.556-1.023-.969-2.1-.969-3.08 0-3.885 3.287-6.049 6.324-6.049s6.324 2.164 6.324 6.049c0 .98-.413 2.057-.97 3.08-.562 1.035-1.306 2.075-2.039 2.996a38 38 0 0 1-2.87 3.195l-.05.05-.014.012-.004.005zm0 0 .377.39a.543.543 0 0 1-.753 0z",
    clipRule: "evenodd"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.574 5.65c-.923 0-1.626.707-1.626 1.524 0 .816.703 1.522 1.626 1.522S10.2 7.99 10.2 7.174 9.497 5.65 8.574 5.65m-2.71 1.524c0-1.465 1.238-2.607 2.71-2.607s2.71 1.142 2.71 2.607c0 1.464-1.238 2.607-2.71 2.607s-2.71-1.143-2.71-2.607",
    clipRule: "evenodd"
  }
));
export default SvgLocation;
